import Dexie from 'dexie'

export const db = new Dexie('pos_db')
db.version(1).stores(
    {
        store_session: '++id'
    }
)
